import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import { UTXLocalizationResource } from '../../core/i18n';

const en = require('../../src/locale/en.json');
const zhHK = require('../../src/locale/zh_HK.json');
const zhCN = require('../../src/locale/zh_CN.json');
const jaJP = require('../../src/locale/ja_JP.json');

export function I18nModule({ locale }: { locale: string }) {
  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      // the translations
      // (tip move them in a JSON file and import them,
      // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
      resources: {
        ['en-US']: en,
        ['zh-HK']: zhHK,
        ['zh-CN']: zhCN,
        ['ja-JP']: jaJP
      },
      nonExplicitSupportedLngs: true,
      lng: locale, // if you're using a language detector, do not define the lng option
      nsSeparator: '::',
      fallbackLng: 'en-US',

      interpolation: {
        escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      }
    });

  return {
    name: 'I18n',
    i18n: {} as UTXLocalizationResource,
    hooks: () => {
      useTranslation;
    },
    services: {
      addResource: i18n.addResources,
      addResourceBundle: i18n.addResourceBundle,
      getResource: i18n.getResource
    }
  };
}
